import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Brain, Users, LineChart, Scale } from 'lucide-react';
export function Modules() {
  const modules = [{
    icon: <FileText className="w-6 h-6 text-blue-500" data-id="element-125" />,
    title: 'MÓDULO 1: BLINDAJE LEGAL Y ADMINISTRATIVO',
    subtitle: 'Plantillas de Informes Anti-Rebote (CUD, Prepagas y Amparos)',
    description: 'No son modelos genéricos. Son plantillas con la terminología exacta que las auditorías de las prepagas argentinas necesitan leer para autorizar tratamientos, acompañantes terapéuticos y medicación de alto costo.',
    includes: ['Plantilla de Informe para CUD (Neurodesarrollo: TDAH/TEA).', 'Plantilla de Informe para CUD (Deterioro Cognitivo Adulto).', 'Plantilla de Solicitud de Amparos y Continuidad de Tratamiento.', 'Plantilla de Pedido de Medicación de Alto Costo.', 'Checklist de "Palabras Disparadoras" para Auditorías (las 20 frases que una prepaga no puede rechazar).', 'Glosario Legal operativo para el médico (CUD, ANDIS, PMO, MAI).'],
    result: 'Ahorro de tiempo: 40 minutos por informe. Mínimo.'
  }, {
    icon: <Brain className="w-6 h-6 text-blue-500" data-id="element-126" />,
    title: 'MÓDULO 2: BATERÍA DE DIAGNÓSTICO EXPRESS (IN-SITU)',
    subtitle: '8 Fichas de Screening para Observar el Síntoma en tu Consultorio',
    description: 'Dejá de depender de la neuropsicología para tomar decisiones clínicas urgentes. Estas fichas te permiten "provocar" el déficit atencional, la falla mnésica o la rigidez ejecutiva frente a tus ojos en 5-10 minutos.',
    includes: ['Ficha de Rastreo Ejecutivo (TDAH/Conducta).', 'Ficha de Cribado de Memoria (Demencias/Deterioro).', 'Ficha de Atención Sostenida en Niños (TEA/TDAH).', 'Ficha de Praxias y Visoconstrucción.', 'Ficha de Lenguaje y Comprensión.', 'Ficha de Orientación Tiempo-Espacio.', 'Ficha de Funciones Frontales (Adultos).', 'Grilla de Observación Conductual + Guía de Interpretación.'],
    result: 'Resultado: Decisiones clínicas con evidencia observable. No con suposiciones.'
  }, {
    icon: <Users className="w-6 h-6 text-blue-500" data-id="element-127" />,
    title: 'MÓDULO 3: KIT DE DEVOLUCIÓN PARA FAMILIAS',
    subtitle: 'Guías Completas de 40 Páginas para Entregar al Dar el Diagnóstico',
    description: 'El momento más crítico de la consulta neurológica no es el diagnóstico. Es el silencio que viene después. La familia sale sin entender qué tiene su hijo, busca en Google y encuentra información contradictoria que destruye la adherencia al tratamiento.',
    includes: ['Guía completa: ¿Qué es el TDAH? (Con mitos, primeros pasos y FAQ de 10 preguntas).', 'Guía completa: ¿Qué es el TEA? (Con mitos, primeros pasos y FAQ de 10 preguntas).', 'Guía completa: ¿Qué es el Deterioro Cognitivo? (Para cuidadores).'],
    result: 'Resultado: La guía explica por vos lo que no tenés tiempo de repetir 15 veces al día.'
  }, {
    icon: <LineChart className="w-6 h-6 text-blue-500" data-id="element-128" />,
    title: 'MÓDULO 4: MONITORIZACIÓN DATA-DRIVEN',
    subtitle: '6 Planillas de Seguimiento Domiciliario',
    description: 'Transformá "¿cómo estuvo este mes?" en datos concretos. Cuando la familia llega a la consulta de seguimiento con una planilla completada, vos tenés información real para ajustar la medicación o el enfoque terapéutico. Sin relatos vagos. Sin "y... más o menos".',
    includes: ['Planilla de Seguimiento Mensual de Medicación (31 días, con semáforo de estado general).', 'Planilla de Registro de Conductas para Niños (por semana, con totales y tendencia).', 'Planilla de Registro de Efectos Secundarios (por semana).', 'Planilla de Evolución de Habilidades (Adultos/Deterioro Cognitivo).', 'Reporte Pre-Consulta para Padres (para completar la noche anterior).', 'Instructivo para Familias (cómo usar las planillas en 3 pasos).'],
    result: 'Resultado: Consultas de seguimiento más cortas, más precisas y con mejores decisiones.'
  }, {
    icon: <Scale className="w-6 h-6 text-blue-500" data-id="element-129" />,
    title: 'MÓDULO 5: ENCUADRE Y ÉTICA PROFESIONAL',
    subtitle: 'Consentimientos y Protocolos que Protegen tu Matrícula y tu Salud Mental',
    description: '',
    includes: ['Consentimiento Informado (Neurología Infantil) — Ley 26.529.', 'Consentimiento Informado (Psiquiatría Adultos) — Ley 26.657.', 'Consentimiento Informado (Teleconsulta) — Resolución 1054/2020.', 'Protocolo de Comunicación WhatsApp (Con horarios, límites y mensajes elegantes).', 'Guía de Autocuidado Profesional (Para el médico que también necesita un sistema de sostenibilidad).'],
    result: 'Resultado: Consultorio blindado legalmente y WhatsApp que deja de ser una guardia paralela.'
  }];
  return <section className="py-20 bg-[#111827]" data-id="element-130">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-131">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-132">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4" data-id="element-133">
            QUÉ INCLUYE EL MEGA KIT NEURO-PRO
          </h2>
          <p className="text-xl text-gray-400" data-id="element-134">
            Lo que necesitás para que tu consultorio funcione en piloto
            automático:
          </p>
        </motion.div>

        <div className="space-y-8" data-id="element-135">
          {modules.map((mod, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="bg-[#1a2332] border border-gray-800 rounded-2xl p-6 md:p-8 shadow-lg" data-id="element-136">
              <div className="flex items-center gap-4 mb-4" data-id="element-137">
                <div className="p-3 bg-[#0B1426] rounded-lg border border-gray-800" data-id="element-138">
                  {mod.icon}
                </div>
                <h3 className="text-xl md:text-2xl font-bold text-white" data-id="element-139">
                  {mod.title}
                </h3>
              </div>

              <h4 className="text-lg font-semibold text-yellow-500 mb-4" data-id="element-140">
                {mod.subtitle}
              </h4>

              {mod.description && <p className="text-gray-300 mb-6 leading-relaxed" data-id="element-141">
                  {mod.description}
                </p>}

              <div className="mb-6" data-id="element-142">
                <p className="font-semibold text-white mb-3" data-id="element-143">Incluye:</p>
                <ul className="space-y-2" data-id="element-144">
                  {mod.includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-gray-400" data-id="element-145">
                      <span className="text-yellow-500 mt-1 flex-shrink-0" data-id="element-146">
                        •
                      </span>
                      <span data-id="element-147">{item}</span>
                    </li>)}
                </ul>
              </div>

              <div className="bg-yellow-500/10 border border-yellow-500/20 rounded-lg p-4" data-id="element-148">
                <p className="text-yellow-400 font-bold" data-id="element-149">{mod.result}</p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}